import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    selectedService: null,
    selectedSubscription: null,
    cartItems: [],
    slotData: null,
    bookedData: null,
    loading: false,
    error: null,
};

const laundrySlice = createSlice({
    name: "laundry",
    initialState,
    reducers: {
        setSelectedService: (state, action) => {
            state.selectedService = action.payload;
            state.selectedSubscription = null;
        },
        setSelectedSubscription: (state, action) => {
            state.selectedSubscription = action.payload;
            state.selectedService = null;
            state.cartItems = [];
            state.slotData = null;
        },
        addToCart: (state, action) => {
            const newItem = action.payload;
            const existingItem = state.cartItems.find(item => item.id === newItem.id);
            if (!existingItem) {
                state.cartItems.push(newItem);
            }
            state.selectedService = newItem;
            state.selectedSubscription = null;
        },
        removeFromCart: (state, action) => {
            state.cartItems = state.cartItems.filter(item => item.id !== action.payload);
            if (state.selectedService?.id === action.payload) {
                state.selectedService = null;
            }
        },
        clearCart: (state) => {
            state.cartItems = [];
            state.selectedService = null;
            state.selectedSubscription = null;
            state.slotData = null;
            state.bookedData = null;
        },
        setSlotData: (state, action) => {
            state.slotData = action.payload;
        },
        setBookedData: (state, action) => {
            state.bookedData = action.payload;
        },
    },
});

export const {
    setSelectedService,
    setSelectedSubscription,
    addToCart,
    removeFromCart,
    clearCart,
    setSlotData,
    setBookedData,
} = laundrySlice.actions;

export default laundrySlice.reducer;
